import { Tabs, Tab, withStyles, WithStyles, Theme } from '@material-ui/core'
import i18next from 'i18next'
//import { FC } from 'react'

const styles = ({ breakpoints, spacing }: Theme) => ({
  container: {
    'box-sizing': 'border-box',
    width: '100%',
    padding: '0.3rem',
    background: '#F3F4F6',
    borderRadius: '7px',
    marginTop: '16px'
  },
  selected: {
    background: '#ffffff !important',
    borderRadius: '7px',
    border: '1px solid #C3C6D1',
    color: '#49CC5B !important',
    margin: '0px',
    padding: '0px',
    height: '40px !important',
    'box-sizing': 'border-box'
  },
  tab: {
    height: '40px !important',
    margin: '0px',
    padding: '0px'
  }
})

interface ApplicationsTabsProps extends WithStyles {
  currentTab: 'received' | 'rejected' | 'accepted' | 'showingReserved'
  setCurrentTab: React.Dispatch<
    React.SetStateAction<
      'received' | 'rejected' | 'accepted' | 'showingReserved'
    >
  >
  t: i18next.TFunction
  isAdmin: boolean
}

const ApplicationsTabs = ({
  setCurrentTab,
  currentTab,
  t,
  classes,
  isAdmin
}: ApplicationsTabsProps) => (
  <div className={classes.container}>
    <Tabs
      value={currentTab}
      indicatorColor='primary'
      textColor='primary'
      onChange={(event, value) => setCurrentTab(value)}
      aria-label='received and rejected tabs'
      variant='fullWidth'
    >
      <Tab
        label={t('applications.tabs.received')}
        value='received'
        className={currentTab === 'received' ? classes.selected : classes.tab}
      />
      {isAdmin && (
        <Tab
          label={t('applications.tabs.rejected')}
          value='rejected'
          className={currentTab === 'rejected' ? classes.selected : classes.tab}
        />
      )}

      <Tab
        label={t('applications.tabs.accepted')}
        value='accepted'
        className={currentTab === 'accepted' ? classes.selected : classes.tab}
      />
      <Tab
        label={t('applications.tabs.confirmed')}
        value='showingReserved'
        className={
          currentTab === 'showingReserved' ? classes.selected : classes.tab
        }
      />
    </Tabs>
  </div>
)

export default withStyles(styles)(ApplicationsTabs)
